import Lottie from "lottie-react";

import * as animationData from "../../assets/lotties/frame-loading.json";

const LoadingLottie = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    style: {
      width: 350,
      height: 350,
    },
  };

  return (
    <Lottie {...defaultOptions} />
  );
};

export default LoadingLottie;
